<div class="row w-100 pt-3 text-center row-title">
  <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Votre Compte Bancaire</div>
</div>
@if (null !== customer) {
  <div>
    <div class="header-description">
      @if (customer.iban) {
        <div>
          <span class="bold-text">Votre IBAN actuel : </span><span>{{ customer.iban }}</span> / <span class="prixtel-color">{{ customer.bic }}</span>
        </div>
      } @else {
        @if (!customer.iban) {
          <span class="bold-text">Votre IBAN actuel : </span>
          } aucun
        }
        <div [className]="'hr-'+environment.data.brand"></div>
      </div>
      <div class="row w-100 pt-3 text-center margin-auto" style="margin-top: -25px;">
        <div class="col-12">
          <form class="" [formGroup]="paymentForm" (submit)="savePaymentMethod()">
            <div class="form-group pb-2">
              <span class="bold-label-text float-left">Nouvel IBAN*</span>
              <input type="text" class="form-control" placeholder="IBAN" formControlName="iban" required>
              @if (paymentFormSubmitted && paymentForm.controls.iban.errors) {
                <p class="error-message">{{ getError('iban') }}</p>
              }
            </div>
            <div class="form-group pb-2">
              <span class="bold-label-text float-left">Nouveau BIC*</span>
              <input type="text" class="form-control" placeholder="BIC" formControlName="bic" required>
              @if (paymentFormSubmitted && paymentForm.controls.bic.errors) {
                <p class="error-message">{{ getError('bic') }}</p>
              }
            </div>
            <div class="form-group pb-2 checkbox">
                <input type="checkbox" id="generateSepa" (click)="setSepa($event)"/>
                <label for="generateSepa" class="box-grid">En cochant j'accepte la génération de mandat sepa.</label>
            </div>
            <div class="cta_container">
              <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
              @if (acceptSepa) {
                <button class="cta_btn level_2 column" type="submit">Valider<span></span></button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  }


